import { createContext, useContext } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { empresasService } from "app/services";
import { useParams } from "react-router-dom";
import { Spinner } from "app/components";
import { ErrorMessage } from "app/components/error-message";
import { toast } from "react-hot-toast";

const EmpresaContext = createContext();

export function EmpresaProvider({ children }) {
  const params = useParams();

  const empresaQuery = useQuery({
    queryKey: ["empresas:get:empresa", params.empresa_id],
    queryFn: () => empresasService.getEmpresa({ empresaId: params.empresa_id }),
  });

  const empresaUpdateMutation = useMutation({
    queryKey: ["empresas:update:empresa"],
    mutationFn: (data) =>
      toast.promise(empresasService.updateEmpresa(data), {
        loading: "Actualizando la información general...",
        success: (response) => response.statusText,
        error: (error) => error.response.statusText,
      }),
    onSuccess: async () => await empresaQuery.refetch(),
  });

  async function updateEmpresa({ empresa = {} }) {
    return await empresaUpdateMutation.mutateAsync({
      empresaId: params.empresa_id,
      empresa,
    });
  }

  if (!!empresaQuery.isLoading) {
    return <Spinner label="Cargando la empresa..." />;
  } else if (!!empresaQuery.isError) {
    return <ErrorMessage message={empresaQuery.error.response.statusText} />;
  }

  return (
    <EmpresaContext.Provider
      value={{
        data: empresaQuery.data,
        isLoading: empresaQuery.isLoading,
        isFetching: empresaQuery.isFetching,
        refetchEmpresa: empresaQuery.refetch,
        isRefetching: empresaQuery.isRefetching,
        updateEmpresa,
        isUpdating: empresaUpdateMutation.isLoading,
      }}
    >
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresaContext() {
  const empresaContext = useContext(EmpresaContext);

  if (!empresaContext) {
    throw new Error(
      "useEmpresaContext should be used inside the EmpresaProvider."
    );
  }

  return empresaContext;
}
